var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"icon-button",on:{"click":_vm.handleClick}},[_c('img',{staticClass:"icon",attrs:{"src":_vm.iconSrc,"alt":"printer icon"}}),_c('span',{staticClass:"button-text"},[_vm._v(_vm._s(_vm.text))])])
}
var staticRenderFns = []

export { render, staticRenderFns }